import { CONTACT_ECOTIC, hrefTelefon, type ContactEcotic } from '@/shared/utils/contact-ecotic';

interface RandContactEcoticProps {
  /** Implicit contactul din variabilele de build; parametrizabil ca sa se poata proba fara build. */
  contact?: ContactEcotic | null;
  className?: string;
  /**
   * Textul de dinaintea numelui. Implicit «Echipa Ecotic: » — randul de sine statator. `null` cand
   * propozitia dinainte se termina deja cu «…echipa Ecotic :» (panoul inline): un al doilea
   * «Echipa Ecotic» ar repeta subiectul.
   */
  prefix?: string | null;
  /** `<span>` in loc de `<p>`, ca randul sa curga in ACELASI paragraf cu propozitia. */
  inline?: boolean;
}

/**
 * «Echipa Ecotic: <nume>, <telefon>» — sau NIMIC. Cat timp variabilele de build sunt goale (azi:
 * valorile vin de la client) randul nu se afiseaza deloc, in loc sa arate un rand gol. Telefonul e
 * link `tel:`, ca pe un telefon sa se poata suna dintr-o atingere.
 *
 * Boldul pe nume si linkul `tel:` sunt aceleasi in ambele variante; se schimba doar prefixul si
 * elementul care le inconjoara.
 */
export function RandContactEcotic({
  contact = CONTACT_ECOTIC,
  className,
  prefix = 'Echipa Ecotic: ',
  inline = false,
}: RandContactEcoticProps) {
  if (!contact) return null;
  const href = contact.telefon ? hrefTelefon(contact.telefon) : '';

  const continut = (
    <>
      {prefix}
      {contact.nume && <strong>{contact.nume}</strong>}
      {contact.nume && contact.telefon && ', '}
      {contact.telefon &&
        (href ? (
          <a href={href} className="touch-target-link inline-flex items-center underline">
            {contact.telefon}
          </a>
        ) : (
          contact.telefon
        ))}
    </>
  );

  if (inline) return <span data-contact-ecotic>{continut}</span>;

  return (
    <p className={className ?? 'mt-2'} data-contact-ecotic>
      {continut}
    </p>
  );
}
